import React from 'react';

const TituloViguetaWpc = () => {
  return (
    <section 
      className="page-title-section top-position1 bg-img cover-background left-overlay-dark" 
      style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/productos/vigueta-wpc/vigueta-wpc-titulo.jpg)` }} 
      data-overlay-dark="8"
    >
      <div className="container">
        <div className="page-title mx-1-6 mx-lg-2-0 mx-xl-2-6 mx-xxl-2-9">
          <div className="row">
            <div className="col-md-12">
              <h1>Vigueta WPC</h1>
            </div>
            <div className="col-md-12">
              <ul className="ps-0">
                <li><a href="/">Inicio</a></li>
                <li><a href="#!" onClick={(e) => e.preventDefault()}>Muro</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TituloViguetaWpc;